"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var MuiOutlinedInput = function MuiOutlinedInput(theme) {
  var WebkitBoxShadow = theme.palette.type === 'light' ? null : "0 0 0 100px ".concat(theme.palette.background["default"], " inset");
  return {
    /* Styles applied to the root element. */
    root: {
      '&:hover $notchedOutline': {
        borderColor: theme.palette.grey[500]
      },
      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 1
      },
      '&$error $notchedOutline': {
        borderColor: theme.palette.error.main
      },
      '&$disabled $notchedOutline': {
        borderColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused $notchedOutline': {
        borderColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 24
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 24
    },

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      paddingLeft: 24,
      paddingRight: 24,
      paddingTop: 18.5,
      paddingBottom: 10.5,
      '&$marginDense': {
        paddingTop: 6.5,
        paddingBottom: 6.5
      },
      '&.MuiOutlinedInput-multiline .MuiInputBase-inputHiddenLabel': {
        marginTop: 0,
        paddingTop: 0
      }
    },

    /* Styles applied to the `input` element. */
    input: {
      paddingLeft: 24,
      paddingRight: 24,
      paddingTop: 18.5,
      paddingBottom: 10.5,
      '&:-webkit-autofill': {
        WebkitBoxShadow: WebkitBoxShadow,
        borderRadius: 'inherit'
      },
      '&.MuiInputBase-inputHiddenLabel': {
        paddingTop: 14.5,
        paddingBottom: 14.5
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 6.5,
      paddingBottom: 6.5
    },

    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {
      borderColor: theme.palette.grey[400],
      padding: '0 16px',
      '& legend > span': {
        paddingLeft: 8,
        paddingRight: 8
      }
    }
  };
};

var _default = MuiOutlinedInput;
exports["default"] = _default;